import React, { useEffect, useState } from 'react';
import { ICubingService } from './services/ICubingService';
import { Alg } from 'cubing/alg';
import { StackmatState } from './services/ICubingService';

interface StackmatTimerDebugProps {
  service: ICubingService;
}

export const StackmatTimerDebug: React.FC<StackmatTimerDebugProps> = ({ service }) => {
  const [state, setState] = useState<StackmatState>(service.getCurrentState());
  const [isRunning, setRunning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    service.setCallback((newState: React.SetStateAction<StackmatState>) => setState(newState));

    return () => {
      service.stop();
      service.setCallback(() => {});
      setRunning(false);
    };
  }, [service]); // ← re-run if service changes

  const handleStart = async () => {
    setError(null);
    try {
      const deviceId = 
      await service.init('s');
      setRunning(true);
      service.setReady(new Alg("U R U'"));
    } catch (e: any) {
      setError("Failed to start timer: " + (e?.message || e));
    }
  };

  const handleStop = () => {
    service.stop();
    setRunning(false);
  };

  const formatTime = (ms: number): string => {
    const seconds = Math.floor(ms / 1000);
    const thousands = Math.floor(ms % 1000);
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}.${thousands.toString().padStart(3, '0')}`;
  };

  return (
    <div style={{ fontFamily: 'monospace', padding: 20 }}>
      <h2>Timer</h2>

      <div style={{ fontSize: '2rem', margin: '1rem 0' }}>
        {state.on ? formatTime(state.timeMilli) : '--:--.---'}
      </div>

      <div>
        <strong>Status:</strong> {state.running ? 'Running' : 'Idle'} <br />
        <strong>Signal:</strong> {state.signalHeader} <br />
        <strong>Hands:</strong> {state.leftHand ? 'L' : ''} {state.rightHand ? 'R' : ''} <br />
        <strong>Noise:</strong> {state.noise.toFixed(4)} <br />
        <strong>Power:</strong> {state.power.toFixed(4)} <br />
      </div>

      <div style={{ marginTop: 20 }}>
        {isRunning ? (
          <button onClick={handleStop}>Stop</button>
        ) : (
          <button onClick={handleStart}>Start Listening</button>
        )}
      </div>

      {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
    </div>
  );
};
